import React, { useState, useEffect } from "react"
import { Menu, X } from "lucide-react"
import { useTranslation } from "react-i18next"
import LanguageSelector from "./LanguageSelector"

export default function Navbar() {
    const { t } = useTranslation()
    const [isOpen, setIsOpen] = useState(false)
    const [scrolled, setScrolled] = useState(false)

    // Handle scroll effect for sticky navbar
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10)
        }
        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)
    }, [])

    return (
        <nav
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled
                ? "bg-white/90 backdrop-blur-md shadow-sm border-b border-gray-100 py-3"
                : "bg-transparent py-5"
                }`}
        >
            <div className="container mx-auto px-4 md:px-6 flex items-center justify-between">
                <a href="#hero" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
                    {/* Logo placeholder - replace with actual logo */}
                    <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center text-white font-bold text-xl">
                        B
                    </div>
                    <span className={`text-xl font-bold tracking-tight ${scrolled ? 'text-gray-900' : 'text-white'}`}>
                        Bousanm
                    </span>
                </a>

                {/* Desktop Navigation */}
                <div className="hidden md:flex items-center gap-8">
                    <a href="#what-we-do" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/80 hover:text-white'}`}>
                        {t('nav.whatWeDo')}
                    </a>
                    <a href="#product-overview" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/80 hover:text-white'}`}>
                        {t('nav.overview')}
                    </a>
                    <a href="#who-we-serve" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/80 hover:text-white'}`}>
                        {t('nav.whoWeServe')}
                    </a>
                    <a href="#about-us" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/80 hover:text-white'}`}>
                        {t('nav.aboutUs')}
                    </a>
                    <a href="#compliance" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/80 hover:text-white'}`}>
                        {t('nav.compliance')}
                    </a>

                    <div className="pl-4 border-l border-gray-200">
                        <LanguageSelector scrolled={scrolled} />
                    </div>
                </div>

                {/* Mobile Menu Button */}
                <div className="flex items-center gap-4 md:hidden">
                    <LanguageSelector scrolled={scrolled} />
                    <button
                        className="p-2 text-gray-600"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        {isOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>

                {/* Mobile Menu */}
                {isOpen && (
                    <div className="absolute top-full left-0 right-0 bg-white shadow-lg border-b border-gray-100 p-4 flex flex-col gap-4 md:hidden animate-in slide-in-from-top-2">
                        <a href="#what-we-do" className="text-base font-medium text-gray-700 py-2" onClick={() => setIsOpen(false)}>
                            {t('nav.whatWeDo')}
                        </a>
                        <a href="#product-overview" className="text-base font-medium text-gray-700 py-2" onClick={() => setIsOpen(false)}>
                            {t('nav.overview')}
                        </a>
                        <a href="#who-we-serve" className="text-base font-medium text-gray-700 py-2" onClick={() => setIsOpen(false)}>
                            {t('nav.whoWeServe')}
                        </a>
                        <a href="#about-us" className="text-base font-medium text-gray-700 py-2" onClick={() => setIsOpen(false)}>
                            {t('nav.aboutUs')}
                        </a>
                        <a href="#compliance" className="text-base font-medium text-gray-700 py-2" onClick={() => setIsOpen(false)}>
                            {t('nav.compliance')}
                        </a>
                    </div>
                )}
            </div>
        </nav>
    )
}
